import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=2175ba88&"
var script = {}
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports